<!-- One conversation card (PCSA-13169). Modes: the display row (tap to resume;
     3-dot menu for rename / delete), the inline rename editor, and the inline
     delete-confirmation step. -->
<div
  class="orbi-history-item"
  [class.orbi-history-item--active]="isActive"
  [class.orbi-history-item--editing]="editing || confirmingDelete"
  [class.orbi-history-item--locked-disabled]="isDisabledByLock"
>
  <!-- Inline rename editor (design "Conversation Name" card). -->
  <ng-container *ngIf="editing; else notEditing">
    <div class="orbi-history-item__edit">
      <label class="orbi-history-item__edit-label" [attr.for]="renameFieldId"> Conversation Name </label>
      <input
        #renameField
        [id]="renameFieldId"
        type="text"
        class="orbi-history-item__edit-input"
        [formControl]="renameControl"
        [maxlength]="maxTitleLength"
        [attr.aria-describedby]="renameCounterId"
        (click)="$event.stopPropagation()"
      />
      <p [id]="renameCounterId" class="orbi-history-item__edit-counter" [class.orbi-history-item__edit-counter--warn]="charactersWarning">
        {{ counterText }}
      </p>
      <!-- Save leads, Cancel follows (design review: "switch sides and left
           aligned"). Both go full-width + stacked on small screens (styles).

           <ui-button size="small">, not the hand-rolled pills these were (design
           review, "Anatomy of these buttons": "make sure all buttons are SMALL
           (bootstrap)" / "minimum 128px A11Y"). They were declared here at 40px
           with a 16px bold label — bootstrap's DEFAULT button geometry, one step
           above SMALL — so the pair sat taller than every other control the agent
           draws. `btn-sm` is 32px with a 14px label, and `ui-button`'s own
           `minWidth` default is 128, which is `$btn-min-width` ($spacer * 8)
           exactly, so both notes are satisfied by the shared component rather than
           by numbers restated here. `primary` and `secondary` are the same
           azure-filled and azure-outlined ranks the local styles were painting by
           hand (CLAUDE.md: always use the shared components).

           `(click)`, not `(handleClick)`: these handlers take the Event so they can
           stop it — the click lands on the shared component's inner <button> and
           bubbles to this host, where the handler gets the real event. -->
      <div class="orbi-history-item__edit-actions">
        <ui-button
          class="orbi-history-item__edit-save"
          buttonText="Save"
          rank="primary"
          size="small"
          [buttonDisabled]="!canSaveRename"
          (click)="saveRename($event)"
        ></ui-button>
        <ui-button
          class="orbi-history-item__edit-cancel"
          buttonText="Cancel"
          rank="secondary"
          size="small"
          (click)="cancelRename($event)"
        ></ui-button>
      </div>
    </div>
  </ng-container>

  <ng-template #notEditing>
    <!-- Delete confirmation step (AC 9a; copy parity with mobile). -->
    <ng-container *ngIf="confirmingDelete; else displayRow">
      <div #confirmPanel class="orbi-history-item__confirm" role="alertdialog" tabindex="-1" aria-label="Delete this conversation?">
        <p class="orbi-history-item__confirm-title">Delete this conversation?</p>
        <p class="orbi-history-item__confirm-body">This action will permanently remove the conversation from your history.</p>
        <!-- Same SMALL/128px shared pills as the rename row above. Delete keeps
             its own destructive paint (`alertStatus="danger"`, the shared
             component's own red rank) rather than the local red it was declaring:
             this is the one action in the panel that cannot be undone, so it has
             to read as destructive and not as a second primary. -->
        <div class="orbi-history-item__edit-actions">
          <ui-button
            class="orbi-history-item__edit-cancel"
            buttonText="Cancel"
            rank="secondary"
            size="small"
            (click)="cancelDelete($event)"
          ></ui-button>
          <ui-button
            class="orbi-history-item__confirm-delete"
            buttonText="Delete"
            alertStatus="danger"
            size="small"
            (click)="confirmDelete($event)"
          ></ui-button>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <!-- Display row -->
  <ng-template #displayRow>
    <button #row type="button" class="orbi-history-item__main" [disabled]="isDisabledByLock" (click)="onResume()">
      <span class="orbi-history-item__title">{{ title }}</span
      >&ngsp;
      <span class="orbi-history-item__meta">
        <span *ngIf="isActive" class="orbi-history-item__badge orbi-history-item__badge--active">Active</span>&ngsp;
        <span *ngIf="isReadOnly" class="orbi-history-item__badge orbi-history-item__badge--readonly">Read-Only</span>&ngsp;
        <span *ngIf="dateLabel">{{ dateLabel }}</span
        >&ngsp; <span *ngIf="dateLabel" aria-hidden="true">·</span>&ngsp;
        <span>{{ messageCount }} Messages</span>
      </span>
    </button>

    <div *ngIf="showMenu" #menuWrap class="orbi-history-item__menu-wrap" (focusout)="onMenuFocusOut($event)">
      <button
        #menuBtn
        type="button"
        class="orbi-history-item__menu-btn material-icons-round"
        [attr.aria-label]="menuLabel"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen"
        (click)="toggleMenu($event)"
      >
        more_horiz
      </button>
      <div *ngIf="menuOpen" class="orbi-history-item__menu" role="menu" [attr.aria-label]="menuLabel" (keydown)="onMenuKeydown($event)">
        <button
          #menuItem
          *ngIf="showRename"
          type="button"
          class="orbi-history-item__menu-action"
          role="menuitem"
          tabindex="-1"
          (click)="startRename($event)"
        >
          <span class="material-icons-round" aria-hidden="true">edit</span>
          Rename Conversation
        </button>
        <button
          #menuItem
          type="button"
          class="orbi-history-item__menu-action orbi-history-item__menu-action--danger"
          role="menuitem"
          tabindex="-1"
          (click)="onDelete($event)"
        >
          <span class="material-icons-round" aria-hidden="true">delete</span>
          Delete Conversation
        </button>
      </div>
    </div>
  </ng-template>
</div>
